import { connect } from 'react-redux';
import Immutable from 'immutable';
import UUID from 'uuid-js';

export default function jawsConnect(component: Function) {
  const componentUUID = UUID.create().toString();

  function mapStateToProps(state, ownProps) {
    const componentId = ownProps.componentId || componentUUID;

    const { components, jaws, user } = state;
    const componentState = components.get(componentId);
    let items = Immutable.fromJS({});
    let initialized = false;
    let totalSize = 0;

    if (componentState) {
      items = componentState.get('items');
      initialized = componentState.get('initialized');
      totalSize = componentState.get('totalSize');
    }

    return {
      jaws: jaws.instance,
      items,
      initialized,
      totalSize,
      componentId,
      user,
    };
  }

  return connect(mapStateToProps)(component);
}
